import mapboxgl from 'mapbox-gl';

import { isMobile } from '../utils/breakpoint';
import { createMap, renderSubways } from '../utils/map';

const ListingMapHook = {
  mounted() {
    const location = JSON.parse(this.el.dataset.location);
    const [lon, lat] = location['coordinates'];

    this.map = createMap(this.el, lon, lat, { zoom: 13, scrollZoom: false });

    this.map.on('load', () => {
      renderSubways(this.map);
    });

    new mapboxgl.Marker().setLngLat([lon, lat]).addTo(this.map);
  },
};

export default ListingMapHook;
